export default "__VITE_ASSET__2be76510__"